/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_createPartnerRequest } from '../models/api_createPartnerRequest';
import type { api_createPartnerResponse } from '../models/api_createPartnerResponse';
import type { db_GetPartnerRow } from '../models/db_GetPartnerRow';
import type { db_ListPartnersRow } from '../models/db_ListPartnersRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Partners {
    /**
     * Get a list of partners
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param filterModes Filter modes
     * @param search Search string
     * @returns db_ListPartnersRow OK
     * @throws ApiError
     */
    public static listPartners(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        filterModes?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListPartnersRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/partners',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'filter_modes': filterModes,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a partner
     * @param body Partner details
     * @returns api_createPartnerResponse Created
     * @throws ApiError
     */
    public static createPartner(
        body: api_createPartnerRequest,
    ): CancelablePromise<api_createPartnerResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/partners',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a patner record
     * @param id Partner ID
     * @returns db_GetPartnerRow OK
     * @throws ApiError
     */
    public static getPartner(
        id: number,
    ): CancelablePromise<db_GetPartnerRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/partners/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a partner
     * @param id Partner ID
     * @param body Partner details
     * @returns void
     * @throws ApiError
     */
    public static updatePartner(
        id: number,
        body: api_createPartnerRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/partners/{id}',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
